
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.75 15a.751.751 0 01-.744-.844A6.765 6.765 0 016.709 8.25h.085c1.042 0 2.093.25 3.041.724a.75.75 0 01-.336 1.421.753.753 0 01-.335-.079A5.382 5.382 0 006.77 9.75h-.06a5.263 5.263 0 00-5.216 4.594A.751.751 0 01.75 15zM6.75 8.25c-2.275 0-4.125-1.85-4.125-4.125S4.475 0 6.75 0s4.125 1.85 4.125 4.125S9.024 8.25 6.75 8.25zm0-6.75c-1.447 0-2.625 1.178-2.625 2.625S5.303 6.75 6.75 6.75s2.625-1.178 2.625-2.625S8.197 1.5 6.75 1.5zM16.5 6.75c-1.861 0-3.375-1.514-3.375-3.375S14.639 0 16.5 0s3.375 1.514 3.375 3.375S18.361 6.75 16.5 6.75zm0-5.25c-1.034 0-1.875.841-1.875 1.875S15.466 5.25 16.5 5.25s1.875-.841 1.875-1.875S17.534 1.5 16.5 1.5z"}}),_c('path',{attrs:{"d":"M19.823 9a.75.75 0 01-.562-.254 3.696 3.696 0 00-5.535.001.753.753 0 01-1.06.065.752.752 0 01-.065-1.059A5.19 5.19 0 0116.81 6.01a5.162 5.162 0 013.575 1.744A.748.748 0 0119.823 9zM12.75 24a2.252 2.252 0 01-2.25-2.25v-9a2.252 2.252 0 012.25-2.25h9A2.252 2.252 0 0124 12.75v9A2.252 2.252 0 0121.75 24h-9zm0-12a.75.75 0 00-.75.75v9c0 .414.336.75.75.75h9a.75.75 0 00.75-.75v-9a.75.75 0 00-.75-.75h-9z"}}),_c('path',{attrs:{"d":"M14.25 15a.75.75 0 010-1.5h6a.75.75 0 010 1.5h-6zM14.25 18a.75.75 0 010-1.5h6a.75.75 0 010 1.5h-6zM14.25 21a.75.75 0 010-1.5h2.25a.75.75 0 010 1.5h-2.25z"}})])
          )
        }
      }
    